import styled, { keyframes } from 'styled-components';

/**
 * @name 밑으로 위로 올라오는 팝업 키프레임
 */
export const KeyframeSlideUpPopup = keyframes`
  0%{
    transform: translateY(0);
  }
  100%{
    transform: translateY(calc(-100% + 1px));
  }
`;
export const KeyframeSlideDownPopup = keyframes`
  0%{
    transform: translateY(-100%);
  }
  100%{
    transform: translateY(0);
  }
`;

/**
 * @name 밑에서 위로 올라오는 팝업 스타일 컴포넌트
 */
export const StyledSlideUpPopupWrapper = styled.div<{
  zIndex?: number;
  overflow?: string;
}>`
  position: fixed;
  overflow: ${props =>
    props.overflow && props.overflow === 'N' ? '' : 'hidden'};
  z-index: ${({ zIndex }) => (zIndex ? zIndex : 201)};
  top: 100%;
  max-height: 95vh;
  background-color: white;
  border-radius: 1.5rem 1.5rem 0 0;
  &.open {
    animation: ${KeyframeSlideUpPopup} 0.5s 0s ease 1 forwards;
  }
  &.close {
    animation: ${KeyframeSlideDownPopup} 0.5s 0s ease 1 backwards;
  }
  @media screen and (min-width: 740px) {
    width: 414px;
  }
`;

/**
 * @name 밑으로 위로 올라오는 팝업 키프레임
 */
export const KeyframeSlideUpFullScreenPopup = keyframes`
  0%{
    transform: translateY(100%);
  }
  100%{
    transform: translateY(0%);
  }
`;
export const KeyframeSlideDownFullScreenPopup = keyframes`
  0%{
    transform: translateY(0%);
  }
  100%{
    transform: translateY(100%);
  }
`;

/**
 * @name 밑에서 위로 올라오는 풀스크린 팝업 스타일 컴포넌트
 */
export const StyledSlideUpFullScreenPopupWrapper = styled.div<{
  zIndex?: number;
}>`
  position: fixed;
  overflow: hidden;
  z-index: ${props => (props.zIndex ? props.zIndex : 201)};
  top: 0%;
  width: 100%;
  background-color: white;
  &.open {
    animation: ${KeyframeSlideUpFullScreenPopup} 0.5s 0s ease 1 forwards;
  }
  &.close {
    animation: ${KeyframeSlideDownFullScreenPopup} 0.5s 0s ease 1 backwards;
  }
`;
